import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../../service/user-management.service';
import { RecipientManagementService } from '../../../service/recipient-management.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';

@Component({
    selector: 'recipients-list', 
    templateUrl: './recipients-list.component.html',
    styleUrls: ['./recipients-list.component.css']
})
export class RecipientsListComponent implements OnInit {

  search: string = "";
  resultTable: any[] = null;
  cols: any[];
  message: string = '';
  msgs: Message[] = [];

  constructor(private dataService: UserManagementService, private recipientService: RecipientManagementService, private router: Router) {}

  ngOnInit() {
    this.cols = [
      // { field: 'Id', header: '' },
      { field: 'LastName', header: 'שם משפחה' },
      { field: 'FirstName', header: 'שם פרטי' },
      { field: 'EMail', header: 'כתובת מייל' },
      { field: 'Phone1', header: 'טלפון' },
      { field: 'Phone2', header: 'טלפון נוסף' },
      { field: 'Address', header: 'כתובת' },
      { field: 'Active', header: 'פעיל' },
      { field: 'Notes', header: 'הערות' }
    ];

    this.getRecipients();
  }

  getRecipients(): void {
    
      this.recipientService.getRecipients().subscribe((result: any) => {
        this.resultTable = result;
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה באחזור הודעה');
        });
  }

  editRecipient(id) {
    this.router.navigate(['recipient-edit/', id])
  }



  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' תקלה בהורדת קובץ' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/recipient-management/recipients/recipients-list/recipients-list.component.ts